(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-b2b-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.getAttribute('data-hb-init') === '1') return;
    root.setAttribute('data-hb-init', '1');
    var btns = root.querySelectorAll('[data-hb-tab]');
    if (!btns.length) return;
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-hb-tab]');
      if (!b) return;
      var key = b.getAttribute('data-hb-tab');
      for (var i = 0; i < btns.length; i++) {
        var on = btns[i] === b;
        btns[i].classList.toggle('is-on', on);
        btns[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      root.querySelectorAll('[data-hb-hero]').forEach(function (h) {
        h.hidden = h.getAttribute('data-hb-hero') !== key;
      });
      root.querySelectorAll('[data-hb-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-hb-panel') !== key;
      });
      root.querySelectorAll('[data-hb-facts]').forEach(function (f) {
        f.hidden = f.getAttribute('data-hb-facts') !== key;
      });
    });
  }
  function boot() { document.querySelectorAll('[data-hb-audience]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-box-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function makeFormatter(tplRaw) {
    var tpl = tplRaw || '';
    var m = tpl.match(/\d[\d.,]*\d|\d/);
    if (!m) {
      return function (cents) { return (cents / 100).toFixed(2); };
    }
    var num = m[0];
    var prefix = tpl.slice(0, m.index);
    var suffix = tpl.slice(m.index + num.length);
    var c3 = num.charAt(num.length - 3);
    var dec = '';
    var tho = ',';
    if (c3 === ',' || c3 === '.') {
      dec = c3;
      tho = c3 === ',' ? '.' : ',';
    }
    return function (cents) {
      var neg = cents < 0;
      var v = Math.abs(cents) / 100;
      var s = dec ? v.toFixed(2) : String(Math.round(v));
      var parts = s.split('.');
      var ip = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, tho);
      var body = ip;
      if (dec && parts.length > 1) body += dec + parts[1];
      return (neg ? '-' : '') + prefix + body + suffix;
    };
  }

  function unitPrice(v, qty) {
    var price = v.price;
    var best = null;
    var list = v.breaks || [];
    for (var i = 0; i < list.length; i++) {
      if (qty >= list[i].min) {
        if (best === null || list[i].min > best.min) best = list[i];
      }
    }
    if (best !== null) price = best.price;
    return price;
  }

  function tpl(str, map) {
    var out = str || '';
    for (var k in map) {
      if (Object.prototype.hasOwnProperty.call(map, k)) {
        out = out.split('[' + k + ']').join(map[k]);
      }
    }
    return out;
  }

  function init(root) {
    if (!root || root.getAttribute('data-mh-init') === '1') return;
    var cardEls = root.querySelectorAll('[data-mh-card]');
    if (!cardEls.length) return;
    root.setAttribute('data-mh-init', '1');

    var variants = {};
    for (var i = 0; i < cardEls.length; i++) {
      var el = cardEls[i];
      var id = el.getAttribute('data-variant-id');
      var base = parseInt(el.getAttribute('data-price'), 10) || 0;
      var raw = [];
      try {
        raw = JSON.parse(el.getAttribute('data-breaks') || '[]') || [];
      } catch (e) {
        raw = [];
      }
      var breaks = [];
      for (var j = 0; j < raw.length; j++) {
        var min = parseInt(raw[j][0], 10);
        var pr = parseInt(raw[j][1], 10);
        if (!min || !pr) continue;
        if (pr > base) continue;
        if (pr < base * 0.5) continue;
        breaks.push({ min: min, price: pr });
      }
      variants[String(id)] = {
        id: id,
        name: el.getAttribute('data-name') || '',
        price: base,
        max: parseInt(el.getAttribute('data-max'), 10),
        breaks: breaks
      };
    }

    var STEP = parseInt(root.getAttribute('data-box-size'), 10) || 25;
    var CART_URL = root.getAttribute('data-cart-url') || '/cart';
    var fmt = makeFormatter(root.getAttribute('data-money-format'));

    var S = root.querySelector('.mhbox__strings');
    function str(name, fallback) {
      if (!S) return fallback;
      return S.getAttribute('data-s-' + name) || fallback;
    }

    var cards = Array.prototype.slice.call(cardEls);
    var countEl = root.querySelector('[data-mh-count]');
    var goalEl = root.querySelector('[data-mh-goal]');
    var barEl = root.querySelector('[data-mh-bar]');
    var statusEl = root.querySelector('[data-mh-status]');
    var summaryEl = root.querySelector('[data-mh-summary]');
    var totalEl = root.querySelector('[data-mh-total]');
    var addBtn = root.querySelector('[data-mh-add]');
    var addLabel = root.querySelector('[data-mh-add-label]');
    var errEl = root.querySelector('[data-mh-error]');

    var qty = {};
    var busy = false;

    function totalPieces() {
      var t = 0;
      for (var id in qty) {
        if (qty[id] > 0 && variants[id]) t += qty[id];
      }
      return t;
    }

    function showError(msg) {
      if (!errEl) return;
      if (msg) {
        errEl.textContent = msg;
        errEl.hidden = false;
      } else {
        errEl.textContent = '';
        errEl.hidden = true;
      }
    }

    function render() {
      var total = totalPieces();
      var missing = total >= STEP ? 0 : STEP - total;
      var valid = total >= STEP;

      for (var c = 0; c < cards.length; c++) {
        var card = cards[c];
        var id = card.getAttribute('data-variant-id');
        var v = variants[id];
        var q = qty[id] || 0;
        if (q > 0) card.classList.add('is-selected');
        else card.classList.remove('is-selected');
        var input = card.querySelector('[data-mh-qty]');
        if (input && String(q) !== input.value) input.value = String(q);
        var priceEl = card.querySelector('[data-mh-unit-price]');
        if (priceEl && v) priceEl.textContent = fmt(unitPrice(v, q));
      }

      if (countEl) countEl.textContent = String(total);
      if (goalEl) goalEl.textContent = String(STEP);
      if (barEl) barEl.style.width = Math.min(100, (total / STEP) * 100) + '%';

      var msg;
      if (total === 0) msg = str('empty', '');
      else if (valid) msg = tpl(str('ready', ''), { n: total });
      else msg = tpl(str('goal', ''), { n: missing });
      if (statusEl) statusEl.textContent = msg;

      var lines = [];
      var money = 0;
      for (var id2 in qty) {
        var q2 = qty[id2];
        var v2 = variants[id2];
        if (!q2 || !v2) continue;
        var up = unitPrice(v2, q2);
        money += up * q2;
        lines.push({ name: v2.name, q: q2, sub: up * q2 });
      }
      lines.sort(function (a, b) { return a.name.localeCompare(b.name); });

      if (summaryEl) {
        summaryEl.innerHTML = '';
        for (var l = 0; l < lines.length; l++) {
          var li = document.createElement('li');
          var sa = document.createElement('span');
          sa.textContent = lines[l].q + ' \u00D7 ' + lines[l].name;
          var sb = document.createElement('span');
          sb.textContent = fmt(lines[l].sub);
          li.appendChild(sa);
          li.appendChild(sb);
          summaryEl.appendChild(li);
        }
      }

      if (totalEl) totalEl.textContent = total > 0 ? fmt(money) : '\u2014';
      if (addBtn) addBtn.disabled = !valid || busy;
    }


    function setQty(id, next) {
      var v = variants[id];
      if (!v) return;
      var max = typeof v.max === 'number' && !isNaN(v.max) ? v.max : 99999;
      if (next < 0) next = 0;
      if (next > max) next = max;
      qty[id] = next;
      showError(null);
      render();
    }

    root.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('a')) return;

      var inc = e.target.closest('[data-mh-inc]');
      var dec = e.target.closest('[data-mh-dec]');
      if (inc || dec) {
        var card = (inc || dec).closest('[data-mh-card]');
        if (!card) return;
        var id = card.getAttribute('data-variant-id');
        setQty(id, (qty[id] || 0) + (inc ? 1 : -1));
        return;
      }

      if (e.target.closest('[data-mh-reset]')) {
        for (var k in qty) qty[k] = 0;
        showError(null);
        render();
        return;
      }

      if (e.target.closest('[data-mh-add]')) submit();
    });

    root.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      var input = e.target.closest('[data-mh-qty]');
      if (!input) return;
      var card = input.closest('[data-mh-card]');
      if (!card) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n)) n = 0;
      setQty(card.getAttribute('data-variant-id'), n);
    });

    function submit() {
      if (busy) return;
      var total = totalPieces();
      if (total < STEP) return;

      var items = [];
      for (var id in qty) {
        var v = variants[id];
        if (!qty[id] || !v) continue;
        items.push({
          id: parseInt(id, 10),
          quantity: qty[id],
          properties: { _mh_box: 'custom' }
        });
      }
      if (!items.length) return;

      busy = true;
      showError(null);
      if (addLabel) addLabel.textContent = str('adding', '...');
      render();

      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(routeRoot.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (json) {
            return { ok: r.ok, json: json };
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error((res.json && res.json.description) || 'error');
          window.location.assign(CART_URL);
        })
        .catch(function (err) {
          busy = false;
          if (addLabel) addLabel.textContent = str('add', 'Add');
          showError((err && err.message) || str('error', 'Error'));
          render();
        });
    }

    render();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-mh-box-builder]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-quick-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  function makeFmt(tpl) {
    var m = (tpl || '').match(/\d[\d.,]*\d|\d/);
    if (!m) return function (c) { return (c / 100).toFixed(2); };
    var num = m[0], pre = tpl.slice(0, m.index), suf = tpl.slice(m.index + num.length);
    var c3 = num.charAt(num.length - 3), dec = '', tho = ',';
    if (c3 === ',' || c3 === '.') { dec = c3; tho = c3 === ',' ? '.' : ','; }
    return function (cents) {
      var neg = cents < 0, v = Math.abs(cents) / 100;
      var s = dec ? v.toFixed(2) : String(Math.round(v));
      var p = s.split('.');
      var body = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, tho);
      if (dec && p[1]) body += dec + p[1];
      return (neg ? '-' : '') + pre + body + suf;
    };
  }

  function init(root) {
    if (!root || root.getAttribute('data-qo-init') === '1') return;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-qo-item]'));
    if (!rows.length) return;
    root.setAttribute('data-qo-init', '1');

    var fmt = makeFmt(root.getAttribute('data-money'));
    var CART = root.getAttribute('data-cart-url') || '/cart';
    var S = root.querySelector('.qo__strings');
    function str(k, d) { return S ? (S.getAttribute('data-s-' + k) || d) : d; }

    var countEl = root.querySelector('[data-qo-count]');
    var labelEl = root.querySelector('[data-qo-label]');
    var totalEl = root.querySelector('[data-qo-total]');
    var addBtn = root.querySelector('[data-qo-add]');
    var addLbl = root.querySelector('[data-qo-add-label]');
    var errEl = root.querySelector('[data-qo-error]');
    var emptyEl = root.querySelector('[data-qo-empty]');
    var search = root.querySelector('[data-qo-search]');
    var busy = false;

    rows.forEach(function (r) {
      var raw = [];
      try { raw = JSON.parse(r.getAttribute('data-breaks') || '[]') || []; } catch (e) { raw = []; }
      var base = parseInt(r.getAttribute('data-price'), 10) || 0;
      var bl = [];
      for (var i = 0; i < raw.length; i++) {
        var mn = parseInt(raw[i][0], 10), pr = parseInt(raw[i][1], 10);
        if (!mn || !pr || pr > base || pr < base * 0.4) continue;
        bl.push({ min: mn, price: pr });
      }
      bl.sort(function (a, b) { return a.min - b.min; });
      r._base = base;
      r._breaks = bl;
      var hint = r.querySelector('[data-qo-hint]');
      if (hint && bl.length) {
        hint.textContent = str('from', '') .replace('[n]', bl[0].min).replace('[p]', fmt(bl[0].price));
      }
    });

    function unit(r, q) {
      var p = r._base, best = null;
      for (var i = 0; i < r._breaks.length; i++) {
        if (q >= r._breaks[i].min && (!best || r._breaks[i].min > best.min)) best = r._breaks[i];
      }
      return best ? best.price : p;
    }

    function render() {
      var lines = 0, pieces = 0, money = 0;
      rows.forEach(function (r) {
        var input = r.querySelector('[data-qo-qty]');
        var q = input ? parseInt(input.value, 10) : 0;
        if (isNaN(q) || q < 0) q = 0;
        var u = unit(r, q);
        var up = r.querySelector('[data-qo-unit]');
        if (up) up.textContent = fmt(u);
        var sub = r.querySelector('[data-qo-sub]');
        if (sub) sub.textContent = q > 0 ? fmt(u * q) : '\u2014';
        r.classList.toggle('is-on', q > 0);
        if (q > 0) { lines++; pieces += q; money += u * q; }
      });
      if (countEl) countEl.textContent = String(pieces);
      if (labelEl) {
        labelEl.textContent = lines === 0
          ? str('empty', '')
          : str('lines', '').replace('[n]', lines);
      }
      if (totalEl) totalEl.textContent = lines > 0 ? fmt(money) : '\u2014';
      if (addBtn) addBtn.disabled = lines === 0 || busy;
      root.classList.toggle('has-items', lines > 0);
    }

    function filter() {
      var q = (search.value || '').trim().toLowerCase();
      var shown = 0;
      rows.forEach(function (r) {
        var hit = !q || (r.getAttribute('data-search') || '').indexOf(q) !== -1;
        r.hidden = !hit;
        if (hit) shown++;
      });
      root.querySelectorAll('[data-qo-group]').forEach(function (g) {
        var any = Array.prototype.some.call(g.querySelectorAll('[data-qo-item]'), function (r) { return !r.hidden; });
        g.hidden = !any;
      });
      if (emptyEl) emptyEl.hidden = shown > 0;
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a')) e.stopPropagation();
    });

    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-qo-qty]')) { showErr(null); render(); }
      else if (e.target.matches('[data-qo-search]')) filter();
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('[data-qo-qty]')) return;
      e.preventDefault();
      var all = rows.filter(function (r) { return !r.hidden && r.querySelector('[data-qo-qty]'); });
      var cur = all.indexOf(e.target.closest('[data-qo-item]'));
      var next = all[cur + 1];
      if (next) next.querySelector('[data-qo-qty]').focus();
    });

    function showErr(m) {
      if (!errEl) return;
      errEl.textContent = m || '';
      errEl.hidden = !m;
    }

    if (addBtn) addBtn.addEventListener('click', function () {
      if (busy) return;
      var items = [];
      rows.forEach(function (r) {
        var input = r.querySelector('[data-qo-qty]');
        var q = input ? parseInt(input.value, 10) : 0;
        if (!q || q < 1) return;
        items.push({ id: parseInt(r.getAttribute('data-variant-id'), 10), quantity: q });
      });
      if (!items.length) return;
      busy = true; showErr(null);
      if (addLbl) addLbl.textContent = str('adding', '...');
      render();
      var rr = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rr.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
        .then(function (o) {
          if (!o.ok) throw new Error((o.j && o.j.description) || 'error');
          window.location.assign(CART);
        })
        .catch(function (err) {
          busy = false;
          if (addLbl) addLbl.textContent = str('add', 'Add');
          showErr((err && err.message) || str('error', 'Error'));
          render();
        });
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-quick-order]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
